/* eslint-disable */
// const elLang = require('element-ui/lib/locale/lang/ko')
const elLang = require('element-plus/lib/locale/lang/ko')

module.exports = {
  languageName: '한글.',
  ...elLang.default,  
  companyName: 'Shanghai Jingteng Information Technoledge Co., Ltd.',
  invalidRoute: '액세스 경로 오류, 확인하십시오.',
  login: {    
    title: '관리 백그라운드',    
    usernamePlaceholder: '사용자 이름을 입력하십시오',
    passwordPlaceholder: '암호를 입력하십시오',
    sendAuth: "인증 코드 보내기",
    inputAuthCode: "인증번호를 입력하십시오",
    login: "로그인",
    inputUsername: "사용자를 입력하십시오.",
    inputPassword: "암호를 입력하십시오.", 
    tip3: '비밀번호는 6자리 이하여야 합니다.',
    sendMessage: '인증 코드 보내기',
    loginBtn: '로그인',
    techName: 'Jingteng SaaS',
    tipText: '인증번호 발송됨',
    needStrongPass: '당신의 비밀번호가 시스템 비밀번호의 복잡도 요구에 부합되지 않으니 수정한 후에 계속하십시오',
    tip: '프롬프트',
    submit: '확인',
    passwordError: '계정 또는 비밀번호 오류',
    passwordErrorExceedLimitation: '아이디 비밀번호 여러 번 오류, 계정 잠김 15분',
    pemissionDeny: "이 시스템에 로그인할 권한이 없습니다.",
    loginError: "로그인 오류, 네트워크 확인",
    authcodeError: "인증번호 오류"
  },
  regist: {
    title: '새로운 사용자 생성',
    telPlaceholder: '이메일 또는 전화 번호 입력',
    authcodePlaceholder: '인증 코드',
    sendAuth: "인증 코드 보내기",
    registBtn: '등록',
    privacyNote: '저는 "Jingteng 사용자 계약" 및 "개인 정보 보호 정책"에 동의하고 읽었습니다.',
    usernameTip: '5-25 자, 문자 또는 한글을 포함할 수 있습니다.',
    passwordTip: '비밀번호가 요구 사항을 충족시키지 않습니다.',
    confirmPasswordTip: '입력한 암호가 일치하지 않습니다. 다시 입력하십시오.',
    telTip: '전화 번호를 입력하세요.',
    authcodeTip: '인증 코드 입력',
    agreementNote: '동의합니다',
    agreementNote1: '및',
    privacyNote: '개인 정보 보호 정책',
    EULANote: '사용자 프로토콜',
    strongPassNote: '비밀번호는 최소 8 자이어야 하며 대소문자, 숫자 및 특수 문자를 포함해야 합니다',
    agreementTip: '동의하시기 바랍니다',
    userExistsTip: '사용자가 이미 존재합니다. 직접 로그인하십시오',
    registSuccessful: '등록 성공. 로그인하십시오',
    userExists: '사용자가 이미 존재합니다. 다른 전화번호/이메일 주소를 선택하십시오',
    authcodeSent: '인증 코드가 전송되었습니다',
    authcodeError: '인증 코드 전송 오류, 나중에 다시 시도해주세요',
    registFailed: '신청 실패, 새로 고침하여 다시 시도해주세요',
    confirmPassNotMatch: '두 번 입력한 암호가 일치하지 않습니다. 다시 입력하십시오.'
  },
  sicialSignin:{
    aadGlobal: "Azure AD(Global)",
    aadChina: "Azure AD(China)",
    addTenantNotFound: '해당 Azure AD 테넌트를 찾을 수 없습니다. 먼저 Azure AD 테넌트를 바인딩하려면 테넌트 관리자에게 문의하십시오.',
    aadLoginError: 'AAD Login Error'
  },
  twoFactor: {
    title: '이중 검증',
    note: '인증 코드를 받으려면 누르십시오. 아래에 받은 인증 코드를 기입하고 로그인을 확인하십시오.',
    authcodePlaceholder: '문자 인증 코드를 입력하십시오.',
    sendAuthcode: '인증 코드 보내기',
    ok: '확정하다'
  },  
  codeView: {
    title: '관리 백그라운드',   
    note: '장치에 표시되는 9자리 숫자를 입력하십시오.',
    confirm: '제출',
    codeRequire: '9비트 사용자 코드를 모두 입력하십시오.',
    varified: '검증 성공',
    codeError: '커밋 오류, 다시 입력하십시오.'
  },
  errorView: {
    title: '오류가 발생했습니다',
    note: '틀렸어!입력한 주소 접두사를 확인하십시오'
  },
  noteView: {
    success: '검증 성공!' ,
    note: '디바이스로 돌아가기 계속',
    logout: "로그아웃",
    verifyAgain: "재검증"
  }
  
};
